var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m13.885 12 5.724-5.724a1.33 1.33 0 0 0 0-1.885 1.33 1.33 0 0 0-1.885 0L12 10.115 6.276 4.39a1.33 1.33 0 0 0-1.885 0 1.33 1.33 0 0 0 0 1.885L10.115 12 4.39 17.724A1.332 1.332 0 0 0 5.334 20c.34 0 .682-.131.942-.391L12 13.885l5.724 5.724a1.33 1.33 0 0 0 1.885 0 1.33 1.33 0 0 0 0-1.885z"
})));
export default SvgGemClose;